import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import UploadPage from './pages/UploadPage';
import SetLocationPage from './pages/SetLocationPage';
import SellerPage from './pages/SellerPage';
import SellerDashboardPage from './pages/SellerDashboardPage';
import TermsPage from './pages/policies/TermsPage';
import PrivacyPage from './pages/policies/PrivacyPage';
import ShippingPage from './pages/policies/ShippingPage';
import RefundPage from './pages/policies/RefundPage';
import ContactPage from './pages/policies/ContactPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/seller" element={<SellerPage />} />
      <Route path="/upload" element={<UploadPage />} />
      <Route path="/set-location" element={<SetLocationPage />} />
      <Route path="/seller/dashboard" element={<SellerDashboardPage />} />
      <Route path="/customer" element={<HomePage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/shipping" element={<ShippingPage />} />
      <Route path="/refund" element={<RefundPage />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

export default App;
